import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/es";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useField } from "formik";
import get from "lodash/get";
import { FormControlModel } from "types";

const DatePickerForm = ({ questionData, name, visible, label, formik, onBlurCallback }: FormControlModel) => {
  const [field, meta, helper] = useField(name);

  if (!questionData) return <></>;
  return visible ? (
    <LocalizationProvider dateAdapter={AdapterDayjs} locale='es'>
      <Stack spacing={2}>
        <DatePicker
          label={label}
          value={formik.values[name]?.value || ""}
          onChange={(value: Dayjs | null) => {
            if (dayjs(value).format("YYYY-MM-DD") === "Invalid Date") {
              formik.setFieldValue(name, {});
              return;
            }
            formik.setFieldValue(name, {
              value: dayjs(value).format("YYYY-MM-DD"),
              questionID: questionData.id,
            });
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              name={name}
              margin='normal'
              value={formik.values[name]?.value || ""}
              onBlur={() => {
                if (onBlurCallback && typeof onBlurCallback === "function") onBlurCallback(name);
              }}
              error={meta.touched && Boolean(get(meta.error, "value"))}
              helperText={meta.touched && get(meta.error, "value")}
            />
          )}
        />
      </Stack>
    </LocalizationProvider>
  ) : null;
};

export default DatePickerForm;
